import { createPortal } from "react-dom";
import { useEffect, useSyncExternalStore } from "react";
import {
  closeAppAlert,
  getAppAlert,
  subscribeAppAlert,
} from "@/lib/appAlert";
import { TgEmoji } from "@/components/TgEmoji";
import {
  popupActionsCol,
  popupBtnDanger,
  popupBtnGhost,
  popupBtnPrimary,
} from "@/lib/popupButtons";

/**
 * Наш in-app алерт замість системного tg.showAlert (юзер 2026-06-11).
 * Монтується ОДИН раз у корені (App). Підписується на стор appAlert і
 * рендерить модал у стилі платформи (як LockedSectionPopup). Через portal
 * у body — щоб не обрізалось Layout'ом і fixed працював від viewport.
 */
export function AppAlert() {
  const state = useSyncExternalStore(subscribeAppAlert, getAppAlert, getAppAlert);

  useEffect(() => {
    if (!state) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [state]);

  if (!state) return null;

  const buttons =
    state.buttons && state.buttons.length > 0
      ? state.buttons
      : [{ label: "Зрозуміло", variant: "primary" as const }];

  return createPortal(
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-4"
      onClick={closeAppAlert}
    >
      <div
        className="w-full max-w-sm bg-surface rounded-3xl p-5 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center mb-4">
          {state.emoji && (
            <div className="mb-2 flex justify-center">
              <TgEmoji char={state.emoji} size={44} />
            </div>
          )}
          {state.title && (
            <div className="font-display text-[1.0625rem] font-bold text-ink leading-tight mb-1.5">
              {state.title}
            </div>
          )}
          <div className="text-[0.8125rem] text-ink-dim leading-relaxed [text-wrap:balance] whitespace-pre-wrap">
            {state.message}
          </div>
        </div>
        <div className={popupActionsCol}>
          {buttons.map((b, i) => (
            <button
              key={i}
              type="button"
              onClick={() => {
                closeAppAlert();
                b.onClick?.();
              }}
              className={
                b.variant === "ghost"
                  ? popupBtnGhost
                  : b.variant === "danger"
                    ? popupBtnDanger
                    : popupBtnPrimary
              }
            >
              {b.label}
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
}
